import type { OrgChartCompany } from '@components/pages/OrgCharts/interfaces';
import { recently_updated_api_org_charts_path } from '@routes';

import request from './request';

export interface RecentOrgChartsResponse {
  orgCharts: OrgChartCompany[];
}

export async function getRecentlyUpdatedOrgCharts(): Promise<RecentOrgChartsResponse> {
  return request('get', recently_updated_api_org_charts_path());
}
